import {course_createStudent_Api, course_deleteStudent_Api, course_editStudent_Api,} from 'apis'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {useState} from 'react'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from 'views/AppLocals/factory/createNotification'
import {NullAsDefault} from 'views/Shared'

export const useStudent = ({
  onCreated = NullAsDefault,
  onUpdated = NullAsDefault,
  onDeleted = NullAsDefault,
  autoRefresh = true,
}) => {
  const t = useTranslate()

  const [refreshKey, setRefreshKey] = useState()

  const onError = notifyOnError(t)

  const onRefresh = () => {
    if (autoRefresh) {
      setRefreshKey(Date.now())
    }
  }

  const { handleAsyncAction: onCreate } = useAsyncAction({
    apiInfo: course_createStudent_Api,
    onError,
    onSuccess: (...args) => {
      successNotify(NotificationActionTypes.CREATE, t)
      onRefresh()
      onCreated(...args)
    },
  })

  const { handleAsyncAction: onUpdate } = useAsyncAction({
    apiInfo: course_editStudent_Api,
    onError,
    onSuccess: (...args) => {
      successNotify(NotificationActionTypes.UPDATE, t)
      onUpdated(...args)
    },
  })

  const { handleAsyncAction: onDelete } = useAsyncAction({
    apiInfo: course_deleteStudent_Api,
    onError,
    onSuccess: (...args) => {
      successNotify(NotificationActionTypes.DELETE, t)
      onRefresh()
      onDeleted(...args)
    },
  })

  return {
    onCreate,
    onUpdate,
    onDelete,
    onRefresh,
    refreshKey,
  }
}
